import { FC, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import { ReactComponent as GoogleAdsIcon } from 'src/assets/svg/google-ads.svg'
import { ReactComponent as HaptticLogo } from "src/assets/svg/Hapttic's Logo.svg"
import { useDisableScroll } from 'src/hooks/useDisableScroll'
import classes from './googleAdsComingSoonModal.module.scss'

interface GoogleAdsComingSoonModalProps {
  isOpen: boolean
  onClose: () => void
}

export const GoogleAdsComingSoonModal: FC<GoogleAdsComingSoonModalProps> = ({
  isOpen,
  onClose,
}) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose()
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen, onClose])

  useDisableScroll(isOpen)

  if (!isOpen) return null

  return createPortal(
    <div className={classes.overlay}>
      <div className={classes.modal} ref={ref}>
        <button className={classes.closeButton} onClick={onClose} type="button">
          <svg fill="none" height="24" viewBox="0 0 24 24" width="24">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </svg>
        </button>
        <div className={classes.header}>
          <div className={classes.brand}>
            <HaptticLogo className={classes.brandLogo} />
            <span className={classes.brandName}>Hapttic</span>
          </div>
        </div>

        <div className={classes.body}>
          <GoogleAdsIcon className={classes.platformIcon} />
          <h2 className={classes.title}>Google Ads integration coming soon</h2>
          <p className={classes.message}>
            We&apos;re continuously building tools to help you transform
            fragmented advertising data into actionable competitive
            intelligence. Stay tuned — Google Ads Transparency Center
            integration is coming soon!
          </p>
        </div>

        <div className={classes.footer}>
          <button
            className={classes.doneButton}
            onClick={onClose}
            type="button"
          >
            Done
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
